"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime"); // Libs Tooltip


var harris_icon_font_1 = __importDefault(require("@rotaryintl/harris-icon-font"));

var classnames_1 = __importDefault(require("classnames"));

var react_tooltip_1 = require("react-tooltip");

require("./styles.css");

var Tooltip = function (_a) {
  var className = _a.className,
      content = _a.content,
      _b = _a.place,
      place = _b === void 0 ? 'right' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'dark' : _c;
  var classes = (0, classnames_1.default)(className, {
    'rwc-tooltip': true
  });
  return (0, jsx_runtime_1.jsxs)("span", __assign({
    className: classes
  }, {
    children: [(0, jsx_runtime_1.jsx)("button", __assign({
      className: "button-icon-info",
      "data-tooltip-id": content,
      "data-tooltip-content": content,
      "data-tooltip-variant": variant,
      "data-tooltip-offset": place.includes('bottom') ? 2 : 5,
      "aria-label": "info"
    }, {
      children: (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
        type: "fas-info-circle",
        color: "#39424A",
        size: "24"
      })
    })), (0, jsx_runtime_1.jsx)(react_tooltip_1.Tooltip, {
      id: content,
      place: place,
      className: "tooltip-content"
    })]
  }));
};

exports.default = Tooltip;